export default class App {
  constructor(args = null) {
    this._init(args);
  }

  _init() {
    return;
  }
}
